export default "__VITE_ASSET__D5enGwH7__"